(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('timeRegister', {
        templateUrl: 'views/components/views/timeRegister/timeRegister.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: [
            '$stateParams',
            '$timeout',
            'translateService',
            'modalService',
            'stateService',
            'utilityService',
            'timeRegisterService',
            'trNewJobConfService',
            'logisticService',
            'economyService',
            'projectsService',
            'typeaheadService',
            'rememberService',
            function ($stateParams, $timeout, translateService, modalService, stateService, utilityService, timeRegisterService, trNewJobConfService, logisticService, economyService, projectsService, typeaheadService, rememberService) {
                // #region VARIABLES & DEFINITIONS

                const vm = this;
                let custactNo = $stateParams.custact_no;
                let powTimeKeyno = $stateParams.powtime_keyno;
                let webPageName = stateService.getCurrentName();

                let translations = {
                    confirmation: '',
                    confirm_title: '',
                    confirm_message: '',
                    confirm_ok_label: '',
                    confirm_cancel_label: '',
                    error: '',
                    ok: '',
                };

                vm.model = {
                    projectButtons: [{ id: 'erase', icon: 'fas fa-eraser', type: 'danger', onClick: () => reset('project_keyno') }],
                    projectProcessButtons: [
                        { id: 'erase', icon: 'fas fa-eraser', type: 'danger', onClick: () => reset('projectprosess_keyno') },
                        { id: 'list', icon: 'fas fa-bars', type: 'primary', onClick: () => stateService.go('projectprocesses', { project_keyno: vm.model.edit.project_keyno }) },
                    ],
                    custactButtons: [{ id: 'erase', icon: 'fas fa-eraser', type: 'danger', onClick: () => reset('custact_no') }],
                    equipmentButtons: [{ id: 'list', icon: 'fas fa-bars', type: 'primary', onClick: () => stateService.go('equipments') }],
                    editableEquipmentButtons: [
                        { id: 'list', icon: 'fas fa-bars', type: 'primary', onClick: () => stateService.go('equipments') },
                        { id: 'goto', icon: 'fas fa-chevron-right', type: 'primary', onClick: () => stateService.go('equipmentedit', { equipment_id: vm.model.edit.equipment_id }) },
                    ],
                    operationButtons: [{ id: 'list', icon: 'fas fa-bars', type: 'primary', onClick: () => stateService.go('operations') }],
                    editableOperationButtons: [
                        { id: 'list', icon: 'fas fa-bars', type: 'primary', onClick: () => stateService.go('operations') },
                        { id: 'goto', icon: 'fas fa-chevron-right', type: 'primary', onClick: () => stateService.go('operation', { operation_id: vm.model.edit.operation_id }) },
                    ],
                    offDutyCodesButtons: [{ id: 'erase', icon: 'fas fa-eraser', type: 'danger', onClick: () => reset('offdutycode_keyno') }],
                    edit: {},
                    selectListLabours: [],
                    selectListProjects: [],
                    selectListProjectProcesses: [],
                    selectListDepartments: [],
                    selectListEquipments: [],
                    selectListOperations: [],
                    selectListPercentages: [],
                    selectListSalaryTypes: [],
                    selectListShifts: [],
                    selectListOffDutyCodes: [],
                    selectListCustacts: [],
                    selectListActivitityTypes: [],
                    selectListActivityStatuses: [],
                    itemsListExtraPowTimes: [],
                    validApprove: false,
                    lockedApprove: false,
                    lockedDelete: false,
                    readonlyBreakMinutes: false, // BJS 20240307
                };

                vm.showingDateDateOptions = {
                    date: {
                        show: true,
                        disabled: false,
                        align: 'right',
                    },
                    hour: {
                        show: true,
                        disabled: false,
                        align: 'right',
                    },
                    minute: {
                        show: true,
                        disabled: false,
                        align: 'right',
                        interval: 1,
                    },
                };

                vm.dateOptions = {
                    date: {
                        show: false,
                        disabled: false,
                        align: 'right',
                    },
                    hour: {
                        show: true,
                        disabled: false,
                        align: 'right',
                    },
                    minute: {
                        show: true,
                        disabled: false,
                        align: 'right',
                        interval: 1,
                    },
                };

                // #endregion VARIABLES & DEFINITIONS

                // #region TRANSLATE SERVICE

                async function translate() {
                    let data = await translateService.translateBatch(translations);

                    Object.keys(translations).forEach((key) => {
                        if (data?.[key]) translations[key] = data[key];
                    });
                }

                // #endregion TRANSLATE SERVICE

                // #region LOAD PROCEDURE CALLS

                async function loadEdit() {
                    timeRegisterService
                        .getEdit({
                            custact_no: custactNo,
                            powtime_keyno: powTimeKeyno,
                        })
                        .then((response) => {
                            vm.model.edit = response[0];

                            vm.showingDateDateOptions.minute.interval = +vm.model.edit.timeregister_minutes_precision;
                            vm.dateOptions.minute.interval = +vm.model.edit.timeregister_minutes_precision;

                            vm.showingDateDateOptions = { ...vm.showingDateDateOptions };
                            vm.dateOptions = { ...vm.dateOptions };

                            // BJS 20240307
                            vm.readonlyBreakMinutes = response[0].allow_override_break_minutes !== '1';

                            return Promise.all([
                                loadEquipments(),
                                loadTimeRegisterLabours(),
                                loadProjects(),
                                loadProjectProcesses(),
                                loadDepartments(),
                                loadCustomerActivities(),
                                loadActivityStatuses(),
                                //retrievePrice(),
                                loadExtraPowTimes(),
                                loadPercentages(),
                                loadOperations(),
                            ]);
                        });
                }

                async function loadSalaryTypes() {
                    vm.model.selectListSalaryTypes = await economyService.listSalaryTypes();
                }

                async function loadShifts() {
                    vm.model.selectListShifts = await economyService.listShifts({ only_active: '1' });
                }

                async function loadSelectOffDutyCodes() {
                    vm.model.selectListOffDutyCodes = await trNewJobConfService.listSelectOffDutyCodes();
                }

                async function loadActivitityTypes() {
                    vm.model.selectListActivitityTypes = await economyService.listActivitityTypes({ only_timeentry: '1' });
                }

                async function loadPercentages() {
                    if (utilityService.validateParmsValue(vm.model.edit.custact_no) !== true) return;

                    vm.model.selectListPercentages = await timeRegisterService.listPercentages({ custact_no: vm.model.edit.custact_no });
                }

                async function loadOperations() {
                    if (utilityService.validateParmsValue(vm.model.edit.custact_no) !== true) return;

                    vm.model.selectListOperations = await timeRegisterService.listOperations({ custact_no: vm.model.edit.custact_no });
                }

                async function loadActivityStatuses() {
                    if (utilityService.validateParmsValue(vm.model.edit.activitytype_no) !== true) return;

                    vm.model.selectListActivityStatuses = await economyService.listActivityStatuses({ activitytype_no: vm.model.edit.activitytype_no });
                }

                async function loadEquipments() {
                    if (utilityService.validateParmsValue(vm.model.edit.custact_no) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.edit.labour_no) !== true) return;

                    vm.model.selectListEquipments = await logisticService.listEquipments({
                        custact_no: vm.model.edit.custact_no,
                        labour_no: vm.model.edit.labour_no,
                    });
                }

                async function loadTimeRegisterLabours() {
                    if (utilityService.validateParmsValue(vm.model.edit.businessco_no) !== true) return;

                    vm.model.selectListLabours = await timeRegisterService.loadTimeRegisterLabourList(vm.model.edit.businessco_no);
                }

                async function loadProjects() {
                    if (utilityService.validateParmsValue(vm.model.edit.cust_no) !== true) return;

                    vm.model.selectListProjects = await projectsService.listProjects({
                        bg_projects_activestatus: 'ACTIVE',
                        argtype: 'cust_no',
                        argvalue: vm.model.edit.cust_no,
                    });
                }

                async function loadProjectProcesses() {
                    if (utilityService.validateParmsValue(vm.model.edit.project_keyno, true) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.edit.custact_no, true) !== true) return;

                    vm.model.selectListProjectProcesses = await economyService.listProjectProcesses({
                        project_keyno: vm.model.edit.project_keyno,
                        custact_no: vm.model.edit.custact_no,
                        show_only_timeentry_allowed: '1',
                    });
                }

                async function loadDepartments() {
                    if (utilityService.validateParmsValue(vm.model.edit.businessco_no) !== true) return;

                    vm.model.selectListDepartments = await logisticService.listDepartment({ businessco_no: vm.model.edit.businessco_no });
                }

                async function loadExtraPowTimes() {
                    if (utilityService.validateParmsValue(vm.model.edit.powtime_keyno) !== true) return;

                    vm.model.itemsListExtraPowTimes = await timeRegisterService.listExtraPowTimes({ powtime_keyno: vm.model.edit.powtime_keyno });
                }

                function retrieveBreakMinutes() {
                    if (vm.model.edit.timestamp_start?.trim() && vm.model.edit.timestamp_end?.trim()) {
                        return timeRegisterService.getBreakMinutes(vm.model.edit).then((response) => {
                            vm.model.edit.break_minutes = response[0].breakminutes;
                            vm.model.edit.salaryhours = response[0].salaryhours;

                            recalcQuantityToInvoice();
                            recalcAmount();
                        });
                    }
                }

                function retrieveSalaryHoursToTimeAccount(id) {
                    if (utilityService.validateParmsValue(vm.model.edit.timestamp_start) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.edit.timestamp_end) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.edit.shift_id, true) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.edit.salarytype_id, true) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.edit.overtime_to_timeaccount, true) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.edit.offdutycode_keyno, true) !== true) return;

                    let mergeObj = vm.model.edit;
                    mergeObj.colname_changed = id;

                    return timeRegisterService.getSalaryHoursToTimeAccount(mergeObj).then((response) => {
                        vm.model.edit.salaryhours_to_timeaccount = response[0].salaryhours_to_timeaccount;
                    });
                }

                async function retrievePrice() {
                    if (utilityService.validateParmsValue(vm.model.edit.cust_no) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.edit.custact_no) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.edit.project_keyno) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.edit.projectprosess_keyno, true) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.edit.equipment_id, true) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.edit.prod_id, true) !== true) return;

                    return timeRegisterService
                        .getPrice({
                            cust_no: vm.model.edit.cust_no,
                            custact_no: vm.model.edit.custact_no,
                            project_keyno: vm.model.edit.project_keyno,
                            projectprosess_keyno: vm.model.edit.projectprosess_keyno,
                            equipment_id: vm.model.edit.equipment_id,
                            prod_id: vm.model.edit.prod_id,
                        })
                        .then((response) => {
                            vm.model.edit.price = response[0].price;
                            recalcAmount();
                        });
                }

                async function recalcColumns(colname) {
                    const response = (await timeRegisterService.changeColumn({ ...vm.model.edit, colname_changed: colname }))[0];

                    vm.model.edit = { ...vm.model.edit, ...response };
                }

                vm.onLabourChanged = (event) => {
                    vm.model.edit.labour_no = event;
                    recalcColumns('labour_no');
                };

                function retrieveEquipmentProduct() {
                    if (utilityService.validateParmsValue(vm.model.edit.equipment_id) !== true) return;

                    return timeRegisterService.getEquipmentProduct({ equipment_id: vm.model.edit.equipment_id }).then((response) => {
                        vm.model.edit.prod_id = response[0].prod_id;
                        vm.model.edit.prod_name = response[0].prod_name;

                        retrievePrice();
                        recalcColumns('prod_id');
                    });
                }

                async function loadCustomerActivities() {
                    if (utilityService.validateParmsValue(vm.model.edit.cust_no, true) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.edit.project_keyno, true) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.edit.projectprosess_keyno, true) !== true) return;
                    if (vm.model.edit.custact_no > 0) return;

                    //if (vm.model.edit.project_keyno > 0 || vm.model.edit.projectprosess_keyno > 0) {
                    return timeRegisterService
                        .listCustacts({
                            cust_no: vm.model.edit.cust_no,
                            project_keyno: vm.model.edit.project_keyno,
                            projectprosess_keyno: vm.model.edit.projectprosess_keyno,
                        })
                        .then(function (result) {
                            angular.copy(result, vm.model.selectListCustacts);
                        });
                    //}
                }

                // #region VARIABLES & DEFINITIONS

                var timerProjectProcessKeyno = null;

                // #endregion VARIABLES & DEFINITIONS

                var loadCustact = function () {
                    if (angular.isDefined(timerProjectProcessKeyno)) {
                        $timeout.cancel(timerProjectProcessKeyno);
                    }

                    if (utilityService.validateParmsValue(vm.model.edit.custact_no) !== true) return;

                    if (vm.model.edit.custact_no > 0) {
                        timeRegisterService.changeCustact({ custact_no: vm.model.edit.custact_no }).then(function (response) {
                            vm.model.edit.cust_no = response[0].cust_no;
                            vm.model.edit.cust_name = response[0].cust_name;
                            vm.model.edit.project_keyno = response[0].project_keyno;
                            vm.model.edit.po_keyno = response[0].po_keyno;
                            vm.model.edit.actstatus_keyno = response[0].actstatus_keyno;
                            vm.model.edit.activitytype_no = response[0].activitytype_no;

                            timerProjectProcessKeyno = $timeout(function () {
                                vm.model.edit.projectprosess_keyno = response[0].projectprosess_keyno;
                            }, 500);

                            vm.model.edit.custact_note = response[0].custact_note;
                            var temp_custact_no = vm.model.edit.custact_no;

                            vm.model.edit.custact_no = 0;

                            loadCustomerActivities();
                            recalcColumns('cust_no');

                            vm.model.edit.custact_no = temp_custact_no;

                            if (vm.model.edit.description === '') {
                                vm.model.edit.description = response[0].powtime_description;
                            }
                        });
                    }
                };

                vm.onCustactSearchSelected = async function () {
                    if (vm.model.edit.custact_no > 0) {
                        let response = await timeRegisterService.changeCustact({ custact_no: vm.model.edit.custact_no });
                        vm.model.edit.cust_no = response[0].cust_no;
                        vm.model.edit.cust_name = response[0].cust_name;

                        vm.model.edit.project_keyno = response[0].project_keyno;
                        loadProjects();
                        recalcColumns('cust_no');
                        await vm.onProjectChanged(vm.model.edit.project_keyno);

                        vm.model.edit.projectprosess_keyno = response[0].projectprosess_keyno;
                        await loadProjectProcesses();
                        await vm.onProjectProcessChanged(vm.model.edit.projectprosess_keyno);

                        //await loadCustomerActivities();
                        await loadCustomerActivities();
                        vm.model.edit.custact_no = response[0].custact_no;
                        vm.model.edit.custact_note = response[0].custact_note;

                        vm.model.edit.po_keyno = response[0].po_keyno;

                        //vm.model.edit.custact_no = 0;

                        vm.model.edit.activitytype_no = response[0].activitytype_no;
                        loadActivityStatuses();
                        vm.model.edit.actstatus_keyno = response[0].actstatus_keyno;

                        if (vm.model.edit.description === '') {
                            vm.model.edit.description = response[0].powtime_description;
                        }
                    }
                };

                // #endregion LOAD PROCEDURE CALLS

                // #region RESET BUTTON FUNCTION

                function reset(id) {
                    switch (id) {
                        case 'project_keyno':
                            vm.model.edit.project_keyno = '0';

                            if (vm.model.edit.project_keyno === '0') {
                                return Promise.all([retrievePrice(), loadCustomerActivities(), loadProjectProcesses()]);
                            }
                            break;
                        case 'projectprosess_keyno':
                            vm.model.edit.projectprosess_keyno = '0';

                            if (vm.model.edit.projectprosess_keyno === '0') {
                                return Promise.all([retrievePrice(), loadCustomerActivities()]);
                            }
                            break;
                        case 'custact_no':
                            vm.model.edit.custact_no = '0';

                            loadCustomerActivities();
                            break;
                        case 'offdutycode_keyno':
                            vm.model.edit.offdutycode_keyno = '0';

                            if (vm.model.edit.offdutycode_keyno === '0') {
                                vm.model.edit.salarytype_id = '';
                                vm.model.edit.offdutycode_specification_required = '0';

                                retrieveBreakMinutes();
                                retrieveSalaryHoursToTimeAccount('offdutycode_keyno');
                            }
                            break;
                        default:
                            break;
                    }
                }

                // #endregion RESET BUTTON FUNCTION

                // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

                vm.typeaheadSearch = function (value, id) {
                    switch (id) {
                        case 'cust_name':
                            vm.model.edit[id] = value;

                            return typeaheadService.searchCustomer({
                                cust_name: vm.model.edit[id] || '',
                                filtertype: '',
                                filtervalue: '',
                                custtype: 'C',
                                lastselect: 'SEARCH',
                            });
                            break;
                        case 'custact_note':
                            vm.model.edit[id] = value;

                            return typeaheadService.lookUpCustact({
                                searchtext: vm.model.edit[id] || '',
                                cust_no: vm.model.edit.cust_no,
                                project_keyno: vm.model.edit.project_keyno,
                                projectprosess_keyno: vm.model.edit.projectprosess_keyno,
                                labour_no: vm.model.edit.labour_no,
                            });
                            break;
                        case 'order_searchtext':
                            vm.model.edit[id] = value;

                            return typeaheadService.lookUpOrder({
                                searchtext: vm.model.edit[id] || '',
                                cust_no: vm.model.edit.cust_no,
                            });
                            break;
                        case 'prod_name':
                            vm.model.edit[id] = value;

                            return typeaheadService.searchProduct({
                                prod_name: vm.model.edit[id] || '',
                                webpage_name: webPageName,
                                parm1: '0',
                                parm2: '0',
                                supplier_no: '0',
                                search_only_this_supplier: '0',
                                businessco_no: '0',
                                onlyonstock: '0',
                                model_id: 'ALL',
                            });
                            break;
                        default:
                            break;
                    }
                };

                // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

                // #region SELECTED VALUE FUNCTION

                vm.onTypeaheadSelected = function (item, id) {
                    switch (id) {
                        case 'cust_name':
                            if (item) {
                                vm.model.edit.cust_no = item?.item_id ?? '0';
                                vm.model.edit.cust_name = item?.item_name ?? '';
                                vm.model.edit.project_keyno = '0';
                                vm.model.edit.projectprosess_keyno = '0';

                                loadProjects();
                                retrievePrice();
                                recalcColumns('cust_no');
                            } else {
                                vm.onTypeaheadClear('cust_name');
                            }
                            break;
                        case 'custact_note':
                            if (item) {
                                vm.model.edit.custact_no = item?.item_id ?? '0';
                                vm.model.edit.custact_note = item?.item_name ?? '';

                                vm.onCustactSearchSelected();
                            } else {
                                vm.onTypeaheadClear('custact_note');
                            }
                            break;
                        case 'order_searchtext':
                            if (item) {
                                vm.model.edit.cust_no = item?.cust_no ?? '0';
                                vm.model.edit.project_keyno = item?.project_keyno ?? '0';
                                vm.model.edit.order_internal_no = item?.order_internal_no ?? '0';
                                vm.model.edit.order_offer_no = item?.order_offer_no ?? '0';
                                vm.model.edit.order_order_no = item?.order_order_no ?? '0';
                                vm.model.edit.order_searchtext = item?.item_name ?? '';
                                vm.model.edit.cust_name = item?.cust_name ?? '';

                                recalcColumns('cust_no');
                            } else {
                                vm.onTypeaheadClear('order_searchtext');
                            }
                            break;
                        case 'prod_name':
                            if (item) {
                                vm.model.edit.prod_id = item?.item_id ?? '';
                                vm.model.edit.prod_name = item?.item_name ?? '';

                                retrievePrice();
                                recalcColumns('prod_id');
                            } else {
                                vm.onTypeaheadClear('prod_name');
                            }
                            break;
                        default:
                            break;
                    }
                };

                // #endregion SELECTED VALUE FUNCTION

                // #region CHANGED VALUE FUNCTION

                vm.onTypeaheadChanged = function (value, item, id) {
                    switch (id) {
                        case 'cust_name':
                            vm.model.edit.cust_name = value;

                            if (value) {
                                if (item?.order_order_no) {
                                    vm.model.edit.cust_no = item.cust_no;
                                    vm.model.edit.cust_name = item.cust_name;
                                    vm.model.edit.project_keyno = '0';
                                    vm.model.edit.projectprosess_keyno = '0';
                                }
                            } else {
                                vm.onTypeaheadClear('cust_name');
                                loadProjects();
                                retrievePrice();
                                recalcColumns(id);
                            }
                            break;
                        case 'custact_note':
                            vm.model.edit.custact_note = value;

                            if (value) {
                                if (item?.custact_no) {
                                    vm.model.edit.custact_no = item.custact_no;
                                    vm.model.edit.custact_note = item.custact_note;
                                }
                            } else {
                                vm.onTypeaheadClear('custact_note');
                                vm.onCustactSearchSelected();
                            }
                            break;
                        case 'order_searchtext':
                            vm.model.edit.order_searchtext = value;

                            if (value) {
                                if (item?.order_order_no) {
                                    vm.model.edit.cust_no = item.cust_no;
                                    vm.model.edit.project_keyno = item.project_keyno;
                                    vm.model.edit.order_internal_no = item.order_internal_no;
                                    vm.model.edit.order_offer_no = item.order_offer_no;
                                    vm.model.edit.order_order_no = item.order_order_no;
                                    vm.model.edit.cust_name = item.cust_name;

                                    recalcColumns('cust_no');
                                }
                            } else {
                                vm.onTypeaheadClear('order_searchtext');
                            }
                            break;
                        case 'prod_name':
                            vm.model.edit.prod_name = value;

                            if (value) {
                                if (item?.item_id) {
                                    vm.model.edit.prod_id = item.item_id;
                                    vm.model.edit.prod_name = item.item_name;

                                    recalcColumns('prod_id');
                                }
                            } else {
                                vm.onTypeaheadClear('prod_name');
                                retrievePrice();
                            }
                            break;
                        default:
                            break;
                    }
                };

                // #endregion CHANGED VALUE FUNCTION

                // #region CLEAR VALUE FUNCTION

                vm.onTypeaheadClear = function (id) {
                    switch (id) {
                        case 'cust_name':
                            vm.model.edit.cust_no = '0';
                            vm.model.edit.cust_name = '';
                            vm.model.edit.project_keyno = '0';
                            vm.model.edit.projectprosess_keyno = '0';
                            vm.model.edit.custact_no = '0';
                            vm.model.edit.custact_note = '';
                            vm.model.selectListProjects = [];
                            vm.model.selectListProjectProcesses = [];

                            recalcColumns('cust_no');
                            break;
                        case 'custact_note':
                            vm.model.edit.custact_no = '0';
                            vm.model.edit.custact_note = '';
                            break;
                        case 'order_searchtext':
                            vm.model.edit.cust_no = '0';
                            vm.model.edit.project_keyno = '0';
                            vm.model.edit.order_internal_no = '0';
                            vm.model.edit.order_offer_no = '0';
                            vm.model.edit.order_order_no = '0';
                            vm.model.edit.order_searchtext = '';
                            vm.model.edit.cust_name = '';

                            recalcColumns('cust_no');
                            break;
                        case 'prod_name':
                            vm.model.edit.prod_id = '';
                            vm.model.edit.prod_name = '';

                            recalcColumns('prod_id');
                            break;
                        default:
                            break;
                    }
                };

                // #endregion CLEAR VALUE FUNCTION

                // #region PARSEFLOAT FUNCTION

                var parseNumber = function (str) {
                    if (typeof str === 'string') {
                        str = str.replace(',', '.');
                        str = str.replace(' ', '');

                        if (str === '') {
                            str = '0';
                        }
                    }

                    var out = parseFloat(str);

                    if (isNaN(out)) {
                        out = 0;
                    }

                    if (!isFinite(out)) {
                        out = 0;
                    }

                    return out;
                };

                // #endregion PARSEFLOAT FUNCTION

                // #region RECALCULATION FUNCTIONS

                var recalcQuantityToInvoice = function () {
                    if (vm.model.edit.timestamp_start !== vm.model.edit.timestamp_end) {
                        //console.log('salaryhours: ' + vm.model.edit.salaryhours + ' * pst: ' + vm.model.edit.pst / 100);
                        //vm.model.edit.quantity_toinvoice = parseNumber(vm.model.edit.salaryhours) * parseNumber(vm.model.edit.pst / 100);
                        //vm.onQuantityToInvoiceChanged(parseNumber(vm.model.edit.salaryhours) * parseNumber(vm.model.edit.pst / 100));
                        recalcAmount();
                    }
                };

                var recalcAmount = function () {
                    //console.log('quantity_toinvoice: ' + vm.model.edit.quantity_toinvoice + ' * price: ' + vm.model.edit.price);
                    //* parseNumber(vm.model.edit.pst / 100)
                    vm.model.edit.amount = parseNumber(vm.model.edit.quantity_toinvoice) * (parseNumber(vm.model.edit.price) - parseNumber(vm.model.edit.price) * parseNumber(vm.model.edit.discount / 100));
                    //console.log('amount = ' + vm.model.edit.amount);
                };

                var recalcSumM3ForCargos = function () {
                    //console.log('recalcSumM3ForCargos');
                    //console.log('number_of_cargos: ' + vm.model.edit.number_of_cargos + ' * m3_for_cargos: ' + vm.model.edit.m3_for_cargos);
                    vm.model.edit.sum_m3_for_cargos = parseNumber(vm.model.edit.number_of_cargos) * parseNumber(vm.model.edit.m3_for_cargos);
                };

                // #endregion RECALCULATION FUNCTIONS

                // #region MULTI DIRECTION BUTTON FUNCTIONS

                vm.goToFunc = function (state, e) {
                    function go(parms) {
                        if (e?.ctrlKey) {
                            stateService.newTab(state, parms);
                        } else {
                            stateService.go(state, parms);
                        }
                    }

                    switch (state) {
                        case 'timeregistersplit':
                            timeRegisterService.saveObj(vm.model.edit).then((response) => {
                                if (response[0].ws_result === '1') {
                                    go({ powtime_keyno: vm.model.edit.powtime_keyno });
                                } else {
                                    modalService.show({
                                        type: 'warning',
                                        title: translations.error,
                                        message: response[0].ws_result_message,
                                        buttons: [
                                            {
                                                label: translations.ok,
                                                cssClass: 'btn-warning',
                                                action: (dialogItself) => {
                                                    dialogItself.close();
                                                },
                                            },
                                        ],
                                    });
                                }
                            });
                            break;
                        case 'timesheetdiary':
                            rememberService.remember('w_timesheetdiary.portal_user_keyno', vm.model.edit.portal_user_keyno).then(() => {
                                go({
                                    argtype: '-',
                                    argvalue: '-',
                                });
                            });
                            break;
                        default:
                            break;
                    }
                };

                // #endregion MULTI DIRECTION BUTTON FUNCTIONS

                // #region BUTTON SAVE PROCEDURE FUNCTION CALL

                vm.saveTimeRegister = function () {
                    let mergeObj = {};
                    mergeObj = angular.copy(vm.model.edit);
                    mergeObj.powtimeextras = vm.model.itemsListExtraPowTimes;

                    if (vm.model.validApprove === true) {
                        timeRegisterService.saveObj(mergeObj).then(() => loadApprove());
                    } else {
                        vm.model.edit.locked = '1';

                        timeRegisterService.saveObj(mergeObj).then((response) => {
                            if (response[0].ws_result === '1') {
                                modalService.show({
                                    type: 'success',
                                    title: translations.confirmation,
                                    message: response[0].ws_result_message,
                                    buttons: [
                                        {
                                            label: translations.ok,
                                            cssClass: 'btn-success',
                                            action: (dialogItself) => {
                                                dialogItself.close();
                                                vm.model.edit.locked = '0';

                                                if (window.location.href.includes('ispopup')) {
                                                    window.close();
                                                } else {
                                                    stateService.back();
                                                }
                                            },
                                        },
                                    ],
                                });
                            } else {
                                modalService.show({
                                    type: 'warning',
                                    title: translations.error,
                                    message: response[0].ws_result_message,
                                    buttons: [
                                        {
                                            label: translations.ok,
                                            cssClass: 'btn-warning',
                                            action: (dialogItself) => {
                                                dialogItself.close();
                                                vm.model.edit.locked = '0';
                                            },
                                        },
                                    ],
                                });
                            }
                        });
                    }
                };

                // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

                // #region APPROVE BUTTON FUNCTION

                function loadApprove() {
                    timeRegisterService.approve({ powtime_keyno: vm.model.edit.powtime_keyno }).then((response) => {
                        if (response[0].errorcode !== '0') {
                            modalService.show({
                                type: 'warning',
                                title: translations.error,
                                message: response[0].errormessage,
                                buttons: [
                                    {
                                        label: translations.ok,
                                        cssClass: 'btn-warning',
                                        action: (dialogItself) => {
                                            dialogItself.close();
                                            vm.model.lockedApprove = false;
                                        },
                                    },
                                ],
                            });
                        } else {
                            if (window.location.href.includes('ispopup')) {
                                window.close();
                            } else {
                                stateService.back();
                            }
                            vm.model.lockedApprove = false;
                        }
                    });
                }

                vm.approveTimeRegister = function () {
                    vm.model.lockedApprove = true;
                    vm.model.validApprove = true;

                    vm.saveTimeRegister(true);
                };

                // #endregion APPROVE BUTTON FUNCTION

                // #region BUTTON DELETE PROCEDURE FUNCTION CALL

                vm.deleteValues = function () {
                    vm.model.lockedDelete = true;

                    modalService
                        .confirm({
                            type: 'danger',
                            title: translations.confirm_title,
                            message: translations.confirm_message,
                            okLabel: translations.confirm_ok_label,
                            cancelLabel: translations.confirm_cancel_label,
                        })
                        .then(
                            function () {
                                timeRegisterService.deleteItem({ powtime_keyno: vm.model.edit.powtime_keyno }).then(
                                    function (response) {
                                        if (response[0].errorcode !== '0') {
                                            modalService.show({
                                                type: 'warning',
                                                title: translations.error,
                                                message: response[0].errormessage,
                                                buttons: [
                                                    {
                                                        label: translations.ok,
                                                        cssClass: 'btn-warning',
                                                        action: function (dialogItself) {
                                                            dialogItself.close();
                                                            vm.model.lockedDelete = false;
                                                        },
                                                    },
                                                ],
                                            });
                                        } else {
                                            vm.model.lockedDelete = false;
                                            if (window.location.href.includes('ispopup')) {
                                                window.close();
                                            } else {
                                                stateService.back();
                                            }
                                        }
                                    },
                                    function () {
                                        vm.model.lockedDelete = false;
                                    },
                                );
                            },
                            function () {
                                vm.model.lockedDelete = false;
                            },
                        );
                };

                // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

                // #region ON BLUR MULTI FUNCTIONS

                vm.onBlur = function (id) {
                    switch (id) {
                        case 'salaryhours':
                        case 'amount':
                        case 'quantity_toinvoice':
                            if (utilityService.validateParmsValue(vm.model.edit[id], true) !== true) return;

                            recalcColumns(id);
                            break;
                        default:
                            break;
                    }
                };

                // #endregion ON BLUR MULTI FUNCTIONS

                // #region FIELD CHANGE MULTI FUNCTIONS

                vm.onChanged = function (value, id) {
                    switch (id) {
                        case 'operation_id':
                            if (utilityService.validateWatchValue(value, vm.model.edit[id]) !== true) return;

                            vm.model.edit[id] = value;

                            if (utilityService.validateParmsValue(vm.model.edit[id], true) !== true) return;

                            recalcColumns(id);
                            break;
                        case 'salarytype_id':
                        case 'shift_id':
                        case 'overtime_to_timeaccount':
                            if (utilityService.validateWatchValue(value, vm.model.edit[id]) !== true) return;

                            vm.model.edit[id] = value;

                            if (utilityService.validateParmsValue(vm.model.edit[id], true) !== true) return;

                            //retrieveBreakMinutes();
                            retrieveSalaryHoursToTimeAccount(id);
                            recalcColumns(id);
                            break;
                        default:
                            utilityService.setValueToVariable(value);
                            break;
                    }
                };

                vm.onProjectChanged = async function (value) {
                    vm.model.edit.project_keyno = value;

                    if (value) {
                        return Promise.all([retrievePrice(), loadCustomerActivities(), loadProjectProcesses(), recalcColumns('project_keyno')]);
                    }
                };

                vm.onProjectProcessChanged = async function (value) {
                    vm.model.edit.projectprosess_keyno = value;

                    if (value) {
                        await retrievePrice();
                        await loadCustomerActivities();
                        await recalcColumns('projectprosess_keyno');
                    }
                };

                vm.onEquipmentIdChanged = function (value) {
                    vm.model.edit.equipment_id = value;

                    if (value) {
                        retrievePrice();
                        retrieveEquipmentProduct();
                        recalcColumns('equipment_id');
                    }
                };

                vm.onInvoicePercentageChanged = function (value) {
                    vm.model.edit.pst = value;

                    //console.log('change percentage');

                    if (value) {
                        //console.log('change stuff with percentage');
                        recalcQuantityToInvoice();
                        recalcAmount();
                        recalcColumns('pst');
                    }
                };

                vm.onDiscountChanged = function (value) {
                    vm.model.edit.discount = value;

                    if (value) {
                        //recalcQuantityToInvoice();
                        //recalcAmount();
                        recalcColumns('discount');
                    }
                };

                //vm.onQuantityToInvoiceChanged = function (value) {
                //    vm.model.edit.quantity_toinvoice = value;

                //    if (value) {
                //        //recalcAmount();
                //        recalcColumns('quantity_toinvoice');
                //    }
                //}

                vm.onPriceChanged = function (value) {
                    vm.model.edit.price = value;

                    if (value) {
                        //recalcAmount();
                        recalcColumns('price');
                    }
                };

                vm.onNumberOfCargosChanged = function (value) {
                    vm.model.edit.number_of_cargos = value;

                    if (value) {
                        recalcSumM3ForCargos();
                        recalcColumns('number_of_cargos');
                    }
                };

                vm.onM3ForCargosChanged = function (value) {
                    vm.model.edit.m3_for_cargos = value;

                    if (value) {
                        recalcSumM3ForCargos();
                        recalcColumns('m3_for_cargos');
                    }
                };

                vm.onCustomerActivityChanged = function (value) {
                    vm.model.edit.custact_no = value;
                    loadCustact();
                    recalcColumns('custact_no');
                };

                vm.onActivityTypeChanged = function (value) {
                    vm.model.edit.activitytype_no = value;
                    loadActivityStatuses();
                    recalcColumns('activitytype_no');
                };

                vm.onTimeStampChanged = function (value, timestamp) {
                    if (!value || value.length > 19 || vm.model.edit[timestamp] === value) return;

                    vm.model.edit[timestamp] = value;

                    //retrieveBreakMinutes();
                    retrieveSalaryHoursToTimeAccount(timestamp);
                    recalcColumns(timestamp);
                };

                vm.onBreakMinutesChanged = function (value) {
                    if (vm.model.edit.break_minutes === value) return;

                    vm.model.edit.break_minutes = value;

                    vm.model.edit.break_minutes_modified = 1;

                    //retrieveBreakMinutes(value);
                    recalcColumns('break_minutes');
                };

                vm.onOffDutyCodeChanged = function (value) {
                    vm.model.edit.offdutycode_keyno = value;

                    let offDutyCode = vm.model.selectListOffDutyCodes.find((code) => code.item_id === vm.model.edit.offdutycode_keyno);

                    if (offDutyCode) {
                        vm.model.edit.salarytype_id = offDutyCode.salarytype_id_pay;
                        vm.model.edit.offdutycode_specification_required = offDutyCode.note_required;
                    }

                    retrieveBreakMinutes();
                    retrieveSalaryHoursToTimeAccount('offdutycode_keyno');
                };

                // #endregion FIELD CHANGE MULTI FUNCTIONS

                // #region ANGULAR LIFECYCLE FUNCTION

                vm.$onInit = function () {
                    translate();
                    loadEdit();
                    loadSalaryTypes();
                    loadShifts();
                    loadSelectOffDutyCodes();
                    loadActivitityTypes();
                };

                // #endregion ANGULAR LIFECYCLE FUNCTION
            },
        ],
    });
})();
